/**
 * AnyDoc Translator - Translate Web and PDF
 *
 * Its JS assets are content-hashed Vite output, so the probes target the upsell popup
 * images instead — those keep stable filenames across releases.
 *
 * Manifest verified against version 1.4.20.
 */

import { probeImage } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'aopddeflghjljihihabdclejbojaomaf';

export const anydocTranslator: ExtensionDefinition = {
  id: ID,
  name: 'AnyDoc Translator - Translate Web and PDF',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 6_000_000,
  notes: 'JS bundles are content-hashed; images are the stable probe target.',
  signals: [
    {
      id: 'war-buypopup-image',
      kind: 'web-accessible-resource',
      description:
        'Load public/buypopup/aimodel.png via <img> — an upsell popup asset with a ' +
        'stable filename, exposed to <all_urls>.',
      weight: 1,
      run: () => probeImage(ID, 'public/buypopup/aimodel.png'),
    },
  ],
};
